export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14326.deff9dd7.jpg";